// extracted by mini-css-extract-plugin
module.exports = {"topSection":"WhatIsOjo_topSection__1jdO9","bottomSection":"WhatIsOjo_bottomSection__O_0l_"};